import $api from '../services';

export default {
    list(params) {
        return $api.get('/managers', params);
    },
    create(params) {
        return $api.post('/managers', params);
    },
    read(id) {
        return $api.get(`/managers/${id}`);
    },
    update(id, params) {
        return $api.put(`/managers/${id}`, params);
    },
    updateStatus(id, params) {
        return $api.put(`/managers/${id}/status`, params);
    },
    delete(id) {
        return $api.delete(`/users/managers/${id}`);
    },
    resetPassword(id) {
        return $api.post(`/managers/${id}/reset-password`);
    },
    instructorsBindedToSession() {
        return $api.get('/managers/instructors/binded-to-sessions');
    }
};
